module.exports = __webpack_public_path__ + "static/media/bi_symbol_initial_white_m.1bee67fd.png";